import * as React from "react";
import OrbMultiSelect from "../orb-multiselect";
import { useMutation } from "@tanstack/react-query";
import orbitService from "../../../modules/orbit-module/services/orbit-service";
import { useSelector } from "react-redux";
import { getAuthDetails } from "../../../feature/auth-slice";
import citizenService from "../../../modules/orbit-module/services/citizen-service";
import { useParams } from "react-router";

interface Film {
  usr_name: string;
  title: string;
  year: number;
}

interface Props {
  value: Film[];
  handleChange: any;
  getoptlabel: any;
  placeholder: string;
}

const OrbAsynMultiSelect: React.FC<Props> = ({
  value,
  handleChange,
  getoptlabel,
  placeholder,
}) => {
    const { orbitId, planetId } = useParams();
  const authDetails = useSelector(getAuthDetails);
  const [options, setOptions] = React.useState<any>([]);
  const { mutate: getCitizenList, isPending: isLoading } = useMutation({
    mutationFn: citizenService.getCitizenList,
    onSuccess(data, variables, context) {
      setOptions(data.data);
    },
  });

  const handleOpen = () => {
    const payload = {
      orb_id: orbitId,
      pro_id:Number(planetId)
    };
    getCitizenList(payload);
  };

  return (
    <OrbMultiSelect
      options={options}
      getoptlabel={getoptlabel}
      placeholder={placeholder}
      value={value}
      handleChange={handleChange}
      loading={isLoading}
      onOpen={handleOpen}
    />
  );
};

export default OrbAsynMultiSelect;
